/** Time grid slot size in minutes used by schedule components. */
export const SLOT_MINUTES = 15

/** Minimum pointer movement in pixels before a drag gesture is recognized in section toolbar. */
export const SECTION_TOOLBAR_DRAG_THRESHOLD_PX = 8

/** Interval in ms for continuous zoom when zoom button is held. */
export const PLAN_ZOOM_INTERVAL_MS = 20
